// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"PW-z","sponsoredTooltipWrapper":"QW-z","sponsoredTooltip":"RW-z","newCard":"SW-z"};